module.exports = __webpack_public_path__ + "static/media/mb_barrel_bronze.be1b8c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb_barrel_bronze.png
// module id = 106
// module chunks = 0